export const CustomerSettingsEndpoint = {
  GET_ALL_CUSTOMER_SETTINGS: '/api/admin/setting/customer',
  UPDATE_METAVALUE: '/api/admin/setting/customer/:metakey',
  CREATE_CUSTOMER_SETTING: '/api/admin/setting/customer',
};
